export const ABANDONED_CART_TIMER_KEY = 'abandonedCartPopinSessionTimer';
export const ABANDONED_CART_DISPLAYED_KEY = 'abandonedCartDisplayed';
